import { createFileRoute, redirect } from '@tanstack/react-router';

// Direct visits and post-login navigation land on the workspace launcher.
export const Route = createFileRoute('/_auth/')({
  beforeLoad: () => {
    throw redirect({ to: '/home' });
  },
});
